export default __webpack_public_path__ + "static/media/catalysts_bg_mobile.46bad95a.png";